<template>
  <div class="report-page-template">
    <ReportHeader :heading="heading" :info-text-html="infoTextHtml" :lastUpdate="'Sist oppdatert: ' + lastUpdate" />

    <InfoCard v-if="infoCardText">
      {{ infoCardText }}
    </InfoCard>

    <div class="filter">
      <slot name="filter" />
    </div>
    <DashboardCard v-if="$slots.summary" class="summary" heading="Oppsummering" :loading="loading">
      <slot name="summary">Summary here</slot>
    </DashboardCard>
    <div v-if="loading" class="loading">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    </div>
    <div v-show="!loading" class="report">
      <slot />
    </div>
    <div class="exports">
      <div>Eksporter hele datasettet:</div>
      <button
        class="btn btn-sm btn-loading btn-info"
        @click="$emit('click:export', 'xlsx')"
        :disabled="xlsxLoadingDisabled || xlsxLoading"
      >
        <span v-if="xlsxLoading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span v-else> XLSX </span>
      </button>
      <!--<button
        class="btn btn-sm btn-info"
        @click="$emit('click:export', 'csv')"
      >CSV</button>-->
    </div>
  </div>
</template>

<script>
import ReportHeader from '@/components/reports/ReportHeader';
import DashboardCard from '@/components/DashboardCard';
import InfoCard from '@/components/InfoCard.vue';
import i18nCommon from '@modules/i18n/mixins/Common';

export default {
  name: 'ReportPageTemplate',
  mixins: [i18nCommon],
  props: {
    heading: String,
    infoTextHtml: String,
    lastUpdate: String,
    loading: Boolean,
    xlsxLoadingDisabled: Boolean,
    xlsxLoading: Boolean,
    reportKey: String,
  },
  components: {
    ReportHeader,
    DashboardCard,
    InfoCard,
  },
  computed: {
    infoCardText() {
      return {
        invoiceList: this.translate('reports.reportView.invoiceList.infoCard.text'),
        invoiceSpecification: this.translate('reports.reportView.invoiceSpecification.infoCard.text'),
        paymentList: this.translate('reports.reportView.paymentList.infoCard.text'),
        ageCustomerList: this.translate('reports.reportView.ageCustomerList.infoCard.text'),
        tenancies: this.translate('reports.reportView.tenancies.infoCard.text'),
        rentalObjects: this.translate('reports.reportView.rentalObjects.infoCard.text'),
      }[this.reportKey];
    },
  },
};
</script>

<style scoped lang="scss">
.report-page-template {
  //padding: 1.25rem;
  padding: 3rem;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  height: 100vh;

  > * {
    margin: 0 0 1.25rem 0;
  }
}

.report {
  flex: 1 1 auto;
  background-color: #fff;
  overflow: auto;
  min-height: 300px;
}

.loading {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.exports {
  margin: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  > * {
    margin-right: 0.5rem;
  }
}
</style>
